// extracted by mini-css-extract-plugin
module.exports = {"modalDesktop":"FiltersPopup_modalDesktop__Buby5","modalMobile":"FiltersPopup_modalMobile__kL9KX","content":"FiltersPopup_content__agey_","form":"FiltersPopup_form__9btzn"};